import { useNavigate } from "react-router-dom";
import Container from "./container";
import Button from "./button";
const Projects = (props) => {
  const { title, projects } = props.data;
  const navigate = useNavigate();
  return (
    <Container className={`py-5 md:py-10 space-y-5`}>
      <h4 className="text-2xl md:text-3xl">{title}</h4>
      <div className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {projects.map((project, idx) => {
          return (
            <div className="space-y-2 relative">
              <div className="space-y-4 text-center absolute top-1/2  left-1/2 -translate-x-1/2 -translate-y-1/2 ">
                <p className="text-xl text-white ">{project.title}</p>
                <button
                  onClick={() => navigate(`/projects/${project?.keyword}`)}
                  className="bg-red-600 text-white text-sm px-5 py-2 rounded-full"
                >
                  View Gallery
                </button>
              </div>

              <div className="aspect-video md:aspect-square group">
                <img
                  src={project.images[0]}
                  alt="image"
                  key={idx}
                  className="w-full h-full object-cover F"
                />
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Projects;
